import bannersService from './ws';

export default bannersService;